import styled from 'styled-components';
import CancelPolicySvg from '../../../assets/onboardingNew/homepage/cancel-policy.svg';

const CancelPolicyNewIcon = styled(CancelPolicySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2.2rem'};
height: ${props => props.height || '2.1rem'};
display: flex;
`;

export default CancelPolicyNewIcon;
